import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["upcomingBtn", "recentBtn", "upcomingView", "recentView"]

  showUpcoming() {
    this.upcomingViewTarget.classList.remove("hidden")
    this.recentViewTarget.classList.add("hidden")

    this.upcomingBtnTarget.classList.add("bg-white", "text-core-purple-700", "shadow-sm")
    this.upcomingBtnTarget.classList.remove("text-support-dark-500")
    this.recentBtnTarget.classList.remove("bg-white", "text-core-purple-700", "shadow-sm")
    this.recentBtnTarget.classList.add("text-support-dark-500")

    // Update pip colors
    const upPip = this.upcomingBtnTarget.querySelector("span")
    const rePip = this.recentBtnTarget.querySelector("span")
    if (upPip) { upPip.className = upPip.className.replace("bg-support-dark-400", "bg-core-purple-600") }
    if (rePip) { rePip.className = rePip.className.replace("bg-core-purple-600", "bg-support-dark-400") }
  }

  showRecent() {
    this.upcomingViewTarget.classList.add("hidden")
    this.recentViewTarget.classList.remove("hidden")

    this.recentBtnTarget.classList.add("bg-white", "text-core-purple-700", "shadow-sm")
    this.recentBtnTarget.classList.remove("text-support-dark-500")
    this.upcomingBtnTarget.classList.remove("bg-white", "text-core-purple-700", "shadow-sm")
    this.upcomingBtnTarget.classList.add("text-support-dark-500")

    // Update pip colors
    const upPip = this.upcomingBtnTarget.querySelector("span")
    const rePip = this.recentBtnTarget.querySelector("span")
    if (upPip) { upPip.className = upPip.className.replace("bg-core-purple-600", "bg-support-dark-400") }
    if (rePip) { rePip.className = rePip.className.replace("bg-support-dark-400", "bg-core-purple-600") }
  }
}
